<template>
  <div class="check-item" :class="{ 'is-disabled': disabled }">
    <div
      v-for="(item, index) of items"
      :key="getItemKey(item, index)"
      class="check-item__row"
    >
      <div class="check-item__label">{{ item.label }}</div>
      <div class="check-item__buttons" role="radiogroup">
        <button
          v-for="(button, buttonIndex) of buttons"
          :key="getButtonKey(button, buttonIndex)"
          type="button"
          class="check-item__button"
          :class="{ 'is-active': isSelected(item, button) }"
          role="radio"
          :aria-checked="isSelected(item, button)"
          :disabled="disabled"
          @click="onSelect(item, button)"
        >
          {{ button.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckItem',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    buttons: {
      type: Array,
      default() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getItemKey(item, index) {
      if (item && item.uuid !== undefined && item.uuid !== null && item.uuid !== '') {
        return `item_${item.uuid}`
      }
      if (item && item.value !== undefined && item.value !== null && item.value !== '') {
        return `item_value_${item.value}`
      }
      return `item_index_${index}`
    },
    getButtonKey(button, index) {
      if (button && button.uuid !== undefined && button.uuid !== null && button.uuid !== '') {
        return `btn_${button.uuid}`
      }
      if (button && button.value !== undefined && button.value !== null && button.value !== '') {
        return `btn_value_${button.value}`
      }
      return `btn_index_${index}`
    },
    getItemValue(item) {
      if (!item) {
        return null
      }
      return item.value
    },
    getButtonValue(button) {
      if (!button) {
        return null
      }
      return button.value
    },
    findAnswer(item) {
      const itemValue = this.getItemValue(item)
      const answerList = Array.isArray(this.value) ? this.value : []
      return answerList.find((answer) => {
        return answer && String(answer.itemValue) === String(itemValue)
      }) || null
    },
    isSelected(item, button) {
      const answer = this.findAnswer(item)
      if (!answer) {
        return false
      }
      return String(answer.buttonValue) === String(this.getButtonValue(button))
    },
    onSelect(item, button) {
      if (this.disabled) {
        return
      }
      const itemValue = this.getItemValue(item)
      const buttonValue = this.getButtonValue(button)
      const nextAnswer = {
        itemValue,
        itemLabel: item.label,
        buttonValue,
        buttonLabel: button.label
      }
      const answerList = Array.isArray(this.value) ? [...this.value] : []
      const existIndex = answerList.findIndex((answer) => {
        return answer && String(answer.itemValue) === String(itemValue)
      })
      if (existIndex > -1) {
        answerList.splice(existIndex, 1, nextAnswer)
      } else {
        answerList.push(nextAnswer)
      }
      this.$emit('input', answerList)
      this.$emit('update:value', answerList)
      this.$emit('change', answerList)
    }
  }
}
</script>

<style scoped>
.check-item {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.check-item.is-disabled {
  opacity: 0.85;
}

.check-item__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 40px;
  padding: 8px 14px;
  border-bottom: 1px solid #ebeef5;
  box-sizing: border-box;
}

.check-item__row:last-child {
  border-bottom: none;
}

.check-item__label {
  flex: 1;
  min-width: 0;
  color: #303133;
  font-size: 14px;
  line-height: 24px;
  word-break: break-word;
}

.check-item__buttons {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
}

.check-item__button {
  min-width: 52px;
  height: 28px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #303133;
  font-size: 13px;
  line-height: 26px;
  cursor: pointer;
  outline: none;
  transition: all 0.15s ease;
}

.check-item__button:hover:not(:disabled):not(.is-active) {
  border-color: var(--form-theme-color, #4c4edb);
  color: var(--form-theme-color, #4c4edb);
}

.check-item__button.is-active,
.check-item__button.is-active:hover,
.check-item__button.is-active:focus,
.check-item__button.is-active:active {
  border-color: var(--form-theme-color, #4c4edb);
  background: var(--form-theme-color, #4c4edb);
  color: #fff;
}

.check-item__button:disabled {
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .check-item__row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    min-height: auto;
    padding: 8px 12px;
  }

  .check-item__buttons {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
